export type ConsentValue = "essential" | "all";

const CONSENT_KEY = "craftcivil-cookie-consent";
export const CONSENT_EVENT = "craftcivil:consent-updated";

export function getConsent(): ConsentValue | null {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(CONSENT_KEY);
  if (value === "essential" || value === "all") return value;
  return null;
}

export function setConsent(value: ConsentValue): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(
    new CustomEvent(CONSENT_EVENT, {
      detail: { value },
    })
  );
}

export function hasAnalyticsConsent(): boolean {
  return getConsent() === "all";
}
